// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SmallAccountMenuButton-cls1___2120e49821d90b0d552{/*!*/}.SmallAccountMenuButton-cls2__d8704271ba586c1e210a{width:30px;height:30px;border-radius:50%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SmallAccountMenuButton-cls1___2120e49821d90b0d552",
	"cls2": "SmallAccountMenuButton-cls2__d8704271ba586c1e210a SmallAccountMenuButton-cls1___2120e49821d90b0d552"
};
export default ___CSS_LOADER_EXPORT___;
